// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   THEME SYSTEM - 4 Base Themes × 6 Palettes
   ======================================== */

/* Default theme variables (applied to :root) */
:root {
  /* Light Blue (default) */
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #1da1f2;
  --accent-hover: #1a8cd8;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(29, 161, 242, 0.1);
  --hover-bg-strong: rgba(29, 161, 242, 0.16);
  --hover-background: rgba(29, 161, 242, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(0, 126, 255, 0.04);
  --reputation-bg: #1da1f2;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #1da1f2;
  --primary-hover: #1a8cd8;
}

/* ========================================
   LIGHT THEME VARIATIONS
   ======================================== */

[data-theme="light-blue"] {
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #1da1f2;
  --accent-hover: #1a8cd8;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(29, 161, 242, 0.1);
  --hover-bg-strong: rgba(29, 161, 242, 0.16);
  --hover-background: rgba(29, 161, 242, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(0, 126, 255, 0.04);
  --reputation-bg: #1da1f2;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #1da1f2;
  --primary-hover: #1a8cd8;
  --accent-color: #1da1f2;
  --accent-color-faded: rgba(29, 161, 242, 0.1);
}

[data-theme="light-purple"] {
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #9c27b0;
  --accent-hover: #7b1fa2;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(156, 39, 176, 0.1);
  --hover-bg-strong: rgba(156, 39, 176, 0.16);
  --hover-background: rgba(156, 39, 176, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(156, 39, 176, 0.04);
  --reputation-bg: #9c27b0;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #9c27b0;
  --primary-hover: #7b1fa2;
  --accent-color: #9c27b0;
  --accent-color-faded: rgba(156, 39, 176, 0.1);
}

[data-theme="light-green"] {
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #4caf50;
  --accent-hover: #388e3c;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(76, 175, 80, 0.1);
  --hover-bg-strong: rgba(76, 175, 80, 0.16);
  --hover-background: rgba(76, 175, 80, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(76, 175, 80, 0.04);
  --reputation-bg: #4caf50;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #4caf50;
  --primary-hover: #388e3c;
  --accent-color: #4caf50;
  --accent-color-faded: rgba(76, 175, 80, 0.1);
}

[data-theme="light-orange"] {
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #ff9800;
  --accent-hover: #f57c00;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(255, 152, 0, 0.1);
  --hover-bg-strong: rgba(255, 152, 0, 0.16);
  --hover-background: rgba(255, 152, 0, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(255, 152, 0, 0.04);
  --reputation-bg: #ff9800;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #ff9800;
  --primary-hover: #f57c00;
  --accent-color: #ff9800;
  --accent-color-faded: rgba(255, 152, 0, 0.1);
}

[data-theme="light-pink"] {
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #e91e63;
  --accent-hover: #c2185b;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(233, 30, 99, 0.1);
  --hover-bg-strong: rgba(233, 30, 99, 0.16);
  --hover-background: rgba(233, 30, 99, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(233, 30, 99, 0.04);
  --reputation-bg: #e91e63;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #e91e63;
  --primary-hover: #c2185b;
  --accent-color: #e91e63;
  --accent-color-faded: rgba(233, 30, 99, 0.1);
}

[data-theme="light-teal"] {
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #009688;
  --accent-hover: #00796b;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(0, 150, 136, 0.1);
  --hover-bg-strong: rgba(0, 150, 136, 0.16);
  --hover-background: rgba(0, 150, 136, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(0, 150, 136, 0.04);
  --reputation-bg: #009688;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #009688;
  --primary-hover: #00796b;
  --accent-color: #009688;
  --accent-color-faded: rgba(0, 150, 136, 0.1);
}

[data-theme="light-red"] {
  --bg-primary: #ffffff;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f7f9fa;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #c91e3a;
  --accent-hover: #b01830;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #e1e8ed;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.3);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(224, 36, 94, 0.1);
  --hover-bg-strong: rgba(224, 36, 94, 0.16);
  --hover-background: rgba(224, 36, 94, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(224, 36, 94, 0.04);
  --reputation-bg: #e0245e;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #e1e8ed;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #e0245e;
  --primary-hover: #c01d4f;
  --accent-color: #e0245e;
  --accent-color-faded: rgba(224, 36, 94, 0.1);
}

/* ========================================
   GREYED THEME VARIATIONS
   ======================================== */

[data-theme="greyed-blue"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8e8e8;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #1da1f2;
  --accent-hover: #1a8cd8;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #d1d1d1;
  --shadow-color: rgba(0, 0, 0, 0.08);
  --shadow-strong: rgba(0, 0, 0, 0.2);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(29, 161, 242, 0.1);
  --hover-bg-strong: rgba(29, 161, 242, 0.16);
  --hover-background: rgba(29, 161, 242, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(29, 161, 242, 0.04);
  --reputation-bg: #1da1f2;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #d1d1d1;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #1da1f2;
  --primary-hover: #1a8cd8;
  --accent-color: #1da1f2;
  --accent-color-faded: rgba(29, 161, 242, 0.1);
}

[data-theme="greyed-purple"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8e8e8;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #9c27b0;
  --accent-hover: #7b1fa2;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #d1d1d1;
  --shadow-color: rgba(0, 0, 0, 0.08);
  --shadow-strong: rgba(0, 0, 0, 0.2);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(156, 39, 176, 0.1);
  --hover-bg-strong: rgba(156, 39, 176, 0.16);
  --hover-background: rgba(156, 39, 176, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(156, 39, 176, 0.04);
  --reputation-bg: #9c27b0;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #d1d1d1;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #9c27b0;
  --primary-hover: #7b1fa2;
  --accent-color: #9c27b0;
  --accent-color-faded: rgba(156, 39, 176, 0.1);
}

[data-theme="greyed-green"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8e8e8;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #4caf50;
  --accent-hover: #388e3c;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #d1d1d1;
  --shadow-color: rgba(0, 0, 0, 0.08);
  --shadow-strong: rgba(0, 0, 0, 0.2);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(76, 175, 80, 0.1);
  --hover-bg-strong: rgba(76, 175, 80, 0.16);
  --hover-background: rgba(76, 175, 80, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(76, 175, 80, 0.04);
  --reputation-bg: #4caf50;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #d1d1d1;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #4caf50;
  --primary-hover: #388e3c;
  --accent-color: #4caf50;
  --accent-color-faded: rgba(76, 175, 80, 0.1);
}

[data-theme="greyed-orange"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8e8e8;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #ff9800;
  --accent-hover: #f57c00;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #d1d1d1;
  --shadow-color: rgba(0, 0, 0, 0.08);
  --shadow-strong: rgba(0, 0, 0, 0.2);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(255, 152, 0, 0.1);
  --hover-bg-strong: rgba(255, 152, 0, 0.16);
  --hover-background: rgba(255, 152, 0, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(255, 152, 0, 0.04);
  --reputation-bg: #ff9800;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #d1d1d1;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #ff9800;
  --primary-hover: #f57c00;
  --accent-color: #ff9800;
  --accent-color-faded: rgba(255, 152, 0, 0.1);
}

[data-theme="greyed-pink"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8e8e8;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #e91e63;
  --accent-hover: #c2185b;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #d1d1d1;
  --shadow-color: rgba(0, 0, 0, 0.08);
  --shadow-strong: rgba(0, 0, 0, 0.2);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(233, 30, 99, 0.1);
  --hover-bg-strong: rgba(233, 30, 99, 0.16);
  --hover-background: rgba(233, 30, 99, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(233, 30, 99, 0.04);
  --reputation-bg: #e91e63;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #d1d1d1;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #e91e63;
  --primary-hover: #c2185b;
  --accent-color: #e91e63;
  --accent-color-faded: rgba(233, 30, 99, 0.1);
}

[data-theme="greyed-teal"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8e8e8;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #009688;
  --accent-hover: #00796b;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #d1d1d1;
  --shadow-color: rgba(0, 0, 0, 0.08);
  --shadow-strong: rgba(0, 0, 0, 0.2);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(0, 150, 136, 0.1);
  --hover-bg-strong: rgba(0, 150, 136, 0.16);
  --hover-background: rgba(0, 150, 136, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(0, 150, 136, 0.04);
  --reputation-bg: #009688;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #d1d1d1;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #009688;
  --primary-hover: #00796b;
  --accent-color: #009688;
  --accent-color-faded: rgba(0, 150, 136, 0.1);
}

[data-theme="greyed-red"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e8e8e8;
  --text-primary: #14171a;
  --text-secondary: #657786;
  --text-tertiary: #aab8c2;
  --accent-primary: #c91e3a;
  --accent-hover: #b01830;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #e0245e;
  --error-bg: #ffebef;
  --error-border: #fcc;
  --border-color: #d1d1d1;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --shadow-strong: rgba(0, 0, 0, 0.2);
  --overlay-bg: rgba(0, 0, 0, 0.5);
  --overlay-strong: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(224, 36, 94, 0.1);
  --hover-bg-strong: rgba(224, 36, 94, 0.16);
  --hover-background: rgba(224, 36, 94, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(224, 36, 94, 0.04);
  --reputation-bg: #e0245e;
  --reputation-text: #ffffff;
  --input-bg: #ffffff;
  --input-text: #14171a;
  --input-border: #d1d1d1;
  --input-placeholder: #657786;
  --card-bg: #ffffff;
  --primary-color: #e0245e;
  --primary-hover: #c01d4f;
  --accent-color: #e0245e;
  --accent-color-faded: rgba(224, 36, 94, 0.1);
}

/* ========================================
   DIMMED THEME VARIATIONS
   ======================================== */

[data-theme="dimmed-blue"] {
  --bg-primary: #15202b;
  --bg-secondary: #192734;
  --bg-tertiary: #1e2732;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #1da1f2;
  --accent-hover: #1a8cd8;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #38444d;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(29, 161, 242, 0.1);
  --hover-bg-strong: rgba(29, 161, 242, 0.16);
  --hover-background: rgba(29, 161, 242, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(29, 161, 242, 0.1);
  --reputation-bg: #1da1f2;
  --reputation-text: #ffffff;
  --input-bg: #1e2732;
  --input-text: #f7f9fa;
  --input-border: #38444d;
  --input-placeholder: #6e7f8c;
  --card-bg: #192734;
  --primary-color: #1da1f2;
  --primary-hover: #1a8cd8;
  --accent-color: #1da1f2;
  --accent-color-faded: rgba(29, 161, 242, 0.1);
}

[data-theme="dimmed-purple"] {
  --bg-primary: #15202b;
  --bg-secondary: #192734;
  --bg-tertiary: #1e2732;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #ce93d8;
  --accent-hover: #ba68c8;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #38444d;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(206, 147, 216, 0.1);
  --hover-bg-strong: rgba(206, 147, 216, 0.16);
  --hover-background: rgba(206, 147, 216, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(206, 147, 216, 0.1);
  --reputation-bg: #ce93d8;
  --reputation-text: #000000;
  --input-bg: #1e2732;
  --input-text: #f7f9fa;
  --input-border: #38444d;
  --input-placeholder: #6e7f8c;
  --card-bg: #192734;
  --primary-color: #ce93d8;
  --primary-hover: #ba68c8;
  --accent-color: #ce93d8;
  --accent-color-faded: rgba(206, 147, 216, 0.1);
}

[data-theme="dimmed-green"] {
  --bg-primary: #15202b;
  --bg-secondary: #192734;
  --bg-tertiary: #1e2732;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #66bb6a;
  --accent-hover: #4caf50;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #38444d;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(102, 187, 106, 0.1);
  --hover-bg-strong: rgba(102, 187, 106, 0.16);
  --hover-background: rgba(102, 187, 106, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(102, 187, 106, 0.1);
  --reputation-bg: #66bb6a;
  --reputation-text: #000000;
  --input-bg: #1e2732;
  --input-text: #f7f9fa;
  --input-border: #38444d;
  --input-placeholder: #6e7f8c;
  --card-bg: #192734;
  --primary-color: #66bb6a;
  --primary-hover: #4caf50;
  --accent-color: #66bb6a;
  --accent-color-faded: rgba(102, 187, 106, 0.1);
}

[data-theme="dimmed-orange"] {
  --bg-primary: #15202b;
  --bg-secondary: #192734;
  --bg-tertiary: #1e2732;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #ffb74d;
  --accent-hover: #ffa726;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #38444d;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(255, 183, 77, 0.1);
  --hover-bg-strong: rgba(255, 183, 77, 0.16);
  --hover-background: rgba(255, 183, 77, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(255, 183, 77, 0.1);
  --reputation-bg: #ffb74d;
  --reputation-text: #000000;
  --input-bg: #1e2732;
  --input-text: #f7f9fa;
  --input-border: #38444d;
  --input-placeholder: #6e7f8c;
  --card-bg: #192734;
  --primary-color: #ffb74d;
  --primary-hover: #ffa726;
}

[data-theme="dimmed-pink"] {
  --bg-primary: #15202b;
  --bg-secondary: #192734;
  --bg-tertiary: #1e2732;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #f06292;
  --accent-hover: #ec407a;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #38444d;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(240, 98, 146, 0.1);
  --hover-bg-strong: rgba(240, 98, 146, 0.16);
  --hover-background: rgba(240, 98, 146, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(240, 98, 146, 0.1);
  --reputation-bg: #f06292;
  --reputation-text: #000000;
  --input-bg: #1e2732;
  --input-text: #f7f9fa;
  --input-border: #38444d;
  --input-placeholder: #6e7f8c;
  --card-bg: #192734;
  --primary-color: #f06292;
  --primary-hover: #ec407a;
  --accent-color: #f06292;
  --accent-color-faded: rgba(240, 98, 146, 0.1);
}

[data-theme="dimmed-teal"] {
  --bg-primary: #15202b;
  --bg-secondary: #192734;
  --bg-tertiary: #1e2732;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #4db6ac;
  --accent-hover: #26a69a;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #17bf63;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #38444d;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(77, 182, 172, 0.1);
  --hover-bg-strong: rgba(77, 182, 172, 0.16);
  --hover-background: rgba(77, 182, 172, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(77, 182, 172, 0.1);
  --reputation-bg: #4db6ac;
  --reputation-text: #000000;
  --input-bg: #1e2732;
  --input-text: #f7f9fa;
  --input-border: #38444d;
  --input-placeholder: #6e7f8c;
  --card-bg: #192734;
  --primary-color: #4db6ac;
  --primary-hover: #26a69a;
  --accent-color: #4db6ac;
  --accent-color-faded: rgba(77, 182, 172, 0.1);
}

[data-theme="dimmed-red"] {
  --bg-primary: #15202b;
  --bg-secondary: #192734;
  --bg-tertiary: #1e2732;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #d62547;
  --accent-hover: #c21840;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00c853;
  --error-color: #f06292;
  --error-bg: rgba(240, 98, 146, 0.1);
  --error-border: rgba(240, 98, 146, 0.3);
  --border-color: #38444d;
  --shadow-color: rgba(0, 0, 0, 0.4);
  --shadow-strong: rgba(0, 0, 0, 0.7);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(240, 98, 146, 0.1);
  --hover-bg-strong: rgba(240, 98, 146, 0.16);
  --hover-background: rgba(240, 98, 146, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(240, 98, 146, 0.1);
  --reputation-bg: #f06292;
  --reputation-text: #000000;
  --input-bg: #1e2732;
  --input-text: #f7f9fa;
  --input-border: #38444d;
  --input-placeholder: #6e7f8c;
  --card-bg: #192734;
  --primary-color: #f06292;
  --primary-hover: #ec407a;
  --accent-color: #f06292;
  --accent-color-faded: rgba(240, 98, 146, 0.1);
}

/* ========================================
   DARK THEME VARIATIONS
   ======================================== */

[data-theme="dark-blue"] {
  --bg-primary: #000000;
  --bg-secondary: #16181c;
  --bg-tertiary: #1c1f23;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #1da1f2;
  --accent-hover: #1a8cd8;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00ba7c;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #2f3336;
  --shadow-color: rgba(255, 255, 255, 0.05);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(29, 161, 242, 0.1);
  --hover-bg-strong: rgba(29, 161, 242, 0.16);
  --hover-background: rgba(29, 161, 242, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(29, 161, 242, 0.1);
  --reputation-bg: #1da1f2;
  --reputation-text: #ffffff;
  --input-bg: #16181c;
  --input-text: #f7f9fa;
  --input-border: #2f3336;
  --input-placeholder: #6e7f8c;
  --card-bg: #16181c;
  --primary-color: #1da1f2;
  --primary-hover: #1a8cd8;
  --accent-color: #1da1f2;
  --accent-color-faded: rgba(29, 161, 242, 0.1);
}

[data-theme="dark-purple"] {
  --bg-primary: #000000;
  --bg-secondary: #16181c;
  --bg-tertiary: #1c1f23;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #ce93d8;
  --accent-hover: #ba68c8;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00ba7c;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #2f3336;
  --shadow-color: rgba(255, 255, 255, 0.05);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(206, 147, 216, 0.1);
  --hover-bg-strong: rgba(206, 147, 216, 0.16);
  --hover-background: rgba(206, 147, 216, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(206, 147, 216, 0.1);
  --reputation-bg: #ce93d8;
  --reputation-text: #000000;
  --input-bg: #16181c;
  --input-text: #f7f9fa;
  --input-border: #2f3336;
  --input-placeholder: #6e7f8c;
  --card-bg: #16181c;
  --primary-color: #ce93d8;
  --primary-hover: #ba68c8;
  --accent-color: #ce93d8;
  --accent-color-faded: rgba(206, 147, 216, 0.1);
}

[data-theme="dark-green"] {
  --bg-primary: #000000;
  --bg-secondary: #16181c;
  --bg-tertiary: #1c1f23;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #66bb6a;
  --accent-hover: #4caf50;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00ba7c;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #2f3336;
  --shadow-color: rgba(255, 255, 255, 0.05);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(102, 187, 106, 0.1);
  --hover-bg-strong: rgba(102, 187, 106, 0.16);
  --hover-background: rgba(102, 187, 106, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(102, 187, 106, 0.1);
  --reputation-bg: #66bb6a;
  --reputation-text: #000000;
  --input-bg: #16181c;
  --input-text: #f7f9fa;
  --input-border: #2f3336;
  --input-placeholder: #6e7f8c;
  --card-bg: #16181c;
  --primary-color: #66bb6a;
  --primary-hover: #4caf50;
}

[data-theme="dark-orange"] {
  --bg-primary: #000000;
  --bg-secondary: #16181c;
  --bg-tertiary: #1c1f23;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #ffb74d;
  --accent-hover: #ffa726;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00ba7c;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #2f3336;
  --shadow-color: rgba(255, 255, 255, 0.05);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(255, 183, 77, 0.1);
  --hover-bg-strong: rgba(255, 183, 77, 0.16);
  --hover-background: rgba(255, 183, 77, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(255, 183, 77, 0.1);
  --reputation-bg: #ffb74d;
  --reputation-text: #000000;
  --input-bg: #16181c;
  --input-text: #f7f9fa;
  --input-border: #2f3336;
  --input-placeholder: #6e7f8c;
  --card-bg: #16181c;
  --primary-color: #ffb74d;
  --primary-hover: #ffa726;
  --accent-color: #ffb74d;
  --accent-color-faded: rgba(255, 183, 77, 0.1);
}

[data-theme="dark-pink"] {
  --bg-primary: #000000;
  --bg-secondary: #16181c;
  --bg-tertiary: #1c1f23;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #f06292;
  --accent-hover: #ec407a;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00ba7c;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #2f3336;
  --shadow-color: rgba(255, 255, 255, 0.05);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(240, 98, 146, 0.1);
  --hover-bg-strong: rgba(240, 98, 146, 0.16);
  --hover-background: rgba(240, 98, 146, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(240, 98, 146, 0.1);
  --reputation-bg: #f06292;
  --reputation-text: #000000;
  --input-bg: #16181c;
  --input-text: #f7f9fa;
  --input-border: #2f3336;
  --input-placeholder: #6e7f8c;
  --card-bg: #16181c;
  --primary-color: #f06292;
  --primary-hover: #ec407a;
}

[data-theme="dark-teal"] {
  --bg-primary: #000000;
  --bg-secondary: #16181c;
  --bg-tertiary: #1c1f23;
  --text-primary: #f7f9fa;
  --text-secondary: #8899a6;
  --text-tertiary: #6e7f8c;
  --accent-primary: #4db6ac;
  --accent-hover: #26a69a;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00ba7c;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #2f3336;
  --shadow-color: rgba(255, 255, 255, 0.05);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(77, 182, 172, 0.1);
  --hover-bg-strong: rgba(77, 182, 172, 0.16);
  --hover-background: rgba(77, 182, 172, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(77, 182, 172, 0.1);
  --reputation-bg: #4db6ac;
  --reputation-text: #000000;
  --input-bg: #16181c;
  --input-text: #f7f9fa;
  --input-border: #2f3336;
  --input-placeholder: #6e7f8c;
  --card-bg: #16181c;
  --primary-color: #4db6ac;
  --primary-hover: #26a69a;
  --accent-color: #4db6ac;
  --accent-color-faded: rgba(77, 182, 172, 0.1);
}

[data-theme="dark-red"] {
  --bg-primary: #000000;
  --bg-secondary: #16181c;
  --bg-tertiary: #1c1f23;
  --text-primary: #e7e9ea;
  --text-secondary: #71767b;
  --text-tertiary: #565a5f;
  --accent-primary: #e62e4d;
  --accent-hover: #d6263f;
  --accent-secondary: #667eea;
  --accent-secondary-hover: #3752cc;
  --success-color: #00ba7c;
  --error-color: #ff6b9d;
  --error-bg: #3d1726;
  --error-border: #5d2838;
  --border-color: #2f3336;
  --shadow-color: rgba(255, 255, 255, 0.05);
  --shadow-strong: rgba(0, 0, 0, 0.5);
  --overlay-bg: rgba(0, 0, 0, 0.7);
  --overlay-strong: rgba(0, 0, 0, 0.85);
  --hover-bg: rgba(255, 107, 157, 0.1);
  --hover-bg-strong: rgba(255, 107, 157, 0.16);
  --hover-background: rgba(255, 107, 157, 0.1);
  --like-color: #f91880;
  --like-bg: rgba(249, 24, 128, 0.1);
  --unread-bg: rgba(255, 107, 157, 0.1);
  --reputation-bg: #ff6b9d;
  --reputation-text: #000000;
  --input-bg: #16181c;
  --input-text: #f7f9fa;
  --input-border: #2f3336;
  --input-placeholder: #6e7f8c;
  --card-bg: #16181c;
  --primary-color: #ff6b9d;
  --primary-hover: #ff4081;
  --accent-color: #ff6b9d;
  --accent-color-faded: rgba(255, 107, 157, 0.1);
}

/* Apply theme to body and html */
html, body {
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Input placeholder styling */
input::placeholder,
textarea::placeholder {
  color: var(--input-placeholder);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/themes.css"],"names":[],"mappings":"AAAA;;6CAE6C;;AAE7C,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;6CAE6C;;AAE7C;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;;6CAE6C;;AAE7C;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;;6CAE6C;;AAE7C;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;EAC5C,4CAA4C;EAC5C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;EAC5C,4CAA4C;EAC5C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mCAAmC;EACnC,uCAAuC;EACvC,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;;6CAE6C;;AAE7C;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;EAC5C,4CAA4C;EAC5C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;EAC5C,4CAA4C;EAC5C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;EAC5C,4CAA4C;EAC5C,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,8BAA8B;AAC9B;;EAEE,+BAA+B;EAC/B,UAAU;AACZ","sourcesContent":["/* ========================================\r\n   THEME SYSTEM - 4 Base Themes × 6 Palettes\r\n   ======================================== */\r\n\r\n/* Default theme variables (applied to :root) */\r\n:root {\r\n  /* Light Blue (default) */\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #1da1f2;\r\n  --accent-hover: #1a8cd8;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(29, 161, 242, 0.1);\n  --hover-bg-strong: rgba(29, 161, 242, 0.16);\r\n  --hover-background: rgba(29, 161, 242, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(0, 126, 255, 0.04);\r\n  --reputation-bg: #1da1f2;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #1da1f2;\r\n  --primary-hover: #1a8cd8;\r\n}\r\n\r\n/* ========================================\r\n   LIGHT THEME VARIATIONS\r\n   ======================================== */\r\n\r\n[data-theme=\"light-blue\"] {\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #1da1f2;\r\n  --accent-hover: #1a8cd8;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(29, 161, 242, 0.1);\n  --hover-bg-strong: rgba(29, 161, 242, 0.16);\r\n  --hover-background: rgba(29, 161, 242, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(0, 126, 255, 0.04);\r\n  --reputation-bg: #1da1f2;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #1da1f2;\r\n  --primary-hover: #1a8cd8;\r\n  --accent-color: #1da1f2;\r\n  --accent-color-faded: rgba(29, 161, 242, 0.1);\r\n}\r\n\r\n[data-theme=\"light-purple\"] {\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #9c27b0;\r\n  --accent-hover: #7b1fa2;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(156, 39, 176, 0.1);\n  --hover-bg-strong: rgba(156, 39, 176, 0.16);\r\n  --hover-background: rgba(156, 39, 176, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(156, 39, 176, 0.04);\r\n  --reputation-bg: #9c27b0;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #9c27b0;\r\n  --primary-hover: #7b1fa2;\r\n  --accent-color: #9c27b0;\r\n  --accent-color-faded: rgba(156, 39, 176, 0.1);\r\n}\r\n\r\n[data-theme=\"light-green\"] {\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #4caf50;\r\n  --accent-hover: #388e3c;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(76, 175, 80, 0.1);\n  --hover-bg-strong: rgba(76, 175, 80, 0.16);\r\n  --hover-background: rgba(76, 175, 80, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(76, 175, 80, 0.04);\r\n  --reputation-bg: #4caf50;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #4caf50;\r\n  --primary-hover: #388e3c;\r\n  --accent-color: #4caf50;\r\n  --accent-color-faded: rgba(76, 175, 80, 0.1);\r\n}\r\n\r\n[data-theme=\"light-orange\"] {\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #ff9800;\r\n  --accent-hover: #f57c00;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(255, 152, 0, 0.1);\n  --hover-bg-strong: rgba(255, 152, 0, 0.16);\r\n  --hover-background: rgba(255, 152, 0, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(255, 152, 0, 0.04);\r\n  --reputation-bg: #ff9800;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #ff9800;\r\n  --primary-hover: #f57c00;\r\n  --accent-color: #ff9800;\r\n  --accent-color-faded: rgba(255, 152, 0, 0.1);\r\n}\r\n\r\n[data-theme=\"light-pink\"] {\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #e91e63;\r\n  --accent-hover: #c2185b;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(233, 30, 99, 0.1);\n  --hover-bg-strong: rgba(233, 30, 99, 0.16);\r\n  --hover-background: rgba(233, 30, 99, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(233, 30, 99, 0.04);\r\n  --reputation-bg: #e91e63;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #e91e63;\r\n  --primary-hover: #c2185b;\r\n  --accent-color: #e91e63;\r\n  --accent-color-faded: rgba(233, 30, 99, 0.1);\r\n}\r\n\r\n[data-theme=\"light-teal\"] {\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #009688;\r\n  --accent-hover: #00796b;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(0, 150, 136, 0.1);\n  --hover-bg-strong: rgba(0, 150, 136, 0.16);\r\n  --hover-background: rgba(0, 150, 136, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(0, 150, 136, 0.04);\r\n  --reputation-bg: #009688;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #009688;\r\n  --primary-hover: #00796b;\r\n  --accent-color: #009688;\r\n  --accent-color-faded: rgba(0, 150, 136, 0.1);\r\n}\r\n\r\n[data-theme=\"light-red\"] {\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #f7f9fa;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #c91e3a;\r\n  --accent-hover: #b01830;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #e1e8ed;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.3);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(224, 36, 94, 0.1);\n  --hover-bg-strong: rgba(224, 36, 94, 0.16);\r\n  --hover-background: rgba(224, 36, 94, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(224, 36, 94, 0.04);\r\n  --reputation-bg: #e0245e;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #e1e8ed;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #e0245e;\r\n  --primary-hover: #c01d4f;\r\n  --accent-color: #e0245e;\r\n  --accent-color-faded: rgba(224, 36, 94, 0.1);\r\n}\r\n\r\n/* ========================================\r\n   GREYED THEME VARIATIONS\r\n   ======================================== */\r\n\r\n[data-theme=\"greyed-blue\"] {\r\n  --bg-primary: #f5f5f5;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #e8e8e8;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #1da1f2;\r\n  --accent-hover: #1a8cd8;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #d1d1d1;\r\n  --shadow-color: rgba(0, 0, 0, 0.08);\r\n  --shadow-strong: rgba(0, 0, 0, 0.2);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(29, 161, 242, 0.1);\n  --hover-bg-strong: rgba(29, 161, 242, 0.16);\r\n  --hover-background: rgba(29, 161, 242, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(29, 161, 242, 0.04);\r\n  --reputation-bg: #1da1f2;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #d1d1d1;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #1da1f2;\r\n  --primary-hover: #1a8cd8;\r\n  --accent-color: #1da1f2;\r\n  --accent-color-faded: rgba(29, 161, 242, 0.1);\r\n}\r\n\r\n[data-theme=\"greyed-purple\"] {\r\n  --bg-primary: #f5f5f5;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #e8e8e8;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #9c27b0;\r\n  --accent-hover: #7b1fa2;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #d1d1d1;\r\n  --shadow-color: rgba(0, 0, 0, 0.08);\r\n  --shadow-strong: rgba(0, 0, 0, 0.2);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(156, 39, 176, 0.1);\n  --hover-bg-strong: rgba(156, 39, 176, 0.16);\r\n  --hover-background: rgba(156, 39, 176, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(156, 39, 176, 0.04);\r\n  --reputation-bg: #9c27b0;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #d1d1d1;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #9c27b0;\r\n  --primary-hover: #7b1fa2;\r\n  --accent-color: #9c27b0;\r\n  --accent-color-faded: rgba(156, 39, 176, 0.1);\r\n}\r\n\r\n[data-theme=\"greyed-green\"] {\r\n  --bg-primary: #f5f5f5;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #e8e8e8;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #4caf50;\r\n  --accent-hover: #388e3c;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #d1d1d1;\r\n  --shadow-color: rgba(0, 0, 0, 0.08);\r\n  --shadow-strong: rgba(0, 0, 0, 0.2);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(76, 175, 80, 0.1);\n  --hover-bg-strong: rgba(76, 175, 80, 0.16);\r\n  --hover-background: rgba(76, 175, 80, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(76, 175, 80, 0.04);\r\n  --reputation-bg: #4caf50;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #d1d1d1;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #4caf50;\r\n  --primary-hover: #388e3c;\r\n  --accent-color: #4caf50;\r\n  --accent-color-faded: rgba(76, 175, 80, 0.1);\r\n}\r\n\r\n[data-theme=\"greyed-orange\"] {\r\n  --bg-primary: #f5f5f5;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #e8e8e8;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #ff9800;\r\n  --accent-hover: #f57c00;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #d1d1d1;\r\n  --shadow-color: rgba(0, 0, 0, 0.08);\r\n  --shadow-strong: rgba(0, 0, 0, 0.2);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(255, 152, 0, 0.1);\n  --hover-bg-strong: rgba(255, 152, 0, 0.16);\r\n  --hover-background: rgba(255, 152, 0, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(255, 152, 0, 0.04);\r\n  --reputation-bg: #ff9800;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #d1d1d1;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #ff9800;\r\n  --primary-hover: #f57c00;\r\n  --accent-color: #ff9800;\r\n  --accent-color-faded: rgba(255, 152, 0, 0.1);\r\n}\r\n\r\n[data-theme=\"greyed-pink\"] {\r\n  --bg-primary: #f5f5f5;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #e8e8e8;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #e91e63;\r\n  --accent-hover: #c2185b;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #d1d1d1;\r\n  --shadow-color: rgba(0, 0, 0, 0.08);\r\n  --shadow-strong: rgba(0, 0, 0, 0.2);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(233, 30, 99, 0.1);\n  --hover-bg-strong: rgba(233, 30, 99, 0.16);\r\n  --hover-background: rgba(233, 30, 99, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(233, 30, 99, 0.04);\r\n  --reputation-bg: #e91e63;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #d1d1d1;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #e91e63;\r\n  --primary-hover: #c2185b;\r\n  --accent-color: #e91e63;\r\n  --accent-color-faded: rgba(233, 30, 99, 0.1);\r\n}\r\n\r\n[data-theme=\"greyed-teal\"] {\r\n  --bg-primary: #f5f5f5;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #e8e8e8;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #009688;\r\n  --accent-hover: #00796b;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #d1d1d1;\r\n  --shadow-color: rgba(0, 0, 0, 0.08);\r\n  --shadow-strong: rgba(0, 0, 0, 0.2);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(0, 150, 136, 0.1);\n  --hover-bg-strong: rgba(0, 150, 136, 0.16);\r\n  --hover-background: rgba(0, 150, 136, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(0, 150, 136, 0.04);\r\n  --reputation-bg: #009688;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #d1d1d1;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #009688;\r\n  --primary-hover: #00796b;\r\n  --accent-color: #009688;\r\n  --accent-color-faded: rgba(0, 150, 136, 0.1);\r\n}\r\n\r\n[data-theme=\"greyed-red\"] {\r\n  --bg-primary: #f5f5f5;\r\n  --bg-secondary: #ffffff;\r\n  --bg-tertiary: #e8e8e8;\r\n  --text-primary: #14171a;\r\n  --text-secondary: #657786;\r\n  --text-tertiary: #aab8c2;\r\n  --accent-primary: #c91e3a;\r\n  --accent-hover: #b01830;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #e0245e;\r\n  --error-bg: #ffebef;\r\n  --error-border: #fcc;\r\n  --border-color: #d1d1d1;\r\n  --shadow-color: rgba(0, 0, 0, 0.1);\r\n  --shadow-strong: rgba(0, 0, 0, 0.2);\r\n  --overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --overlay-strong: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(224, 36, 94, 0.1);\n  --hover-bg-strong: rgba(224, 36, 94, 0.16);\r\n  --hover-background: rgba(224, 36, 94, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(224, 36, 94, 0.04);\r\n  --reputation-bg: #e0245e;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #ffffff;\r\n  --input-text: #14171a;\r\n  --input-border: #d1d1d1;\r\n  --input-placeholder: #657786;\r\n  --card-bg: #ffffff;\r\n  --primary-color: #e0245e;\r\n  --primary-hover: #c01d4f;\r\n  --accent-color: #e0245e;\r\n  --accent-color-faded: rgba(224, 36, 94, 0.1);\r\n}\r\n\r\n/* ========================================\r\n   DIMMED THEME VARIATIONS\r\n   ======================================== */\r\n\r\n[data-theme=\"dimmed-blue\"] {\r\n  --bg-primary: #15202b;\r\n  --bg-secondary: #192734;\r\n  --bg-tertiary: #1e2732;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #1da1f2;\r\n  --accent-hover: #1a8cd8;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #38444d;\r\n  --shadow-color: rgba(0, 0, 0, 0.3);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(29, 161, 242, 0.1);\n  --hover-bg-strong: rgba(29, 161, 242, 0.16);\r\n  --hover-background: rgba(29, 161, 242, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(29, 161, 242, 0.1);\r\n  --reputation-bg: #1da1f2;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #1e2732;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #38444d;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #192734;\r\n  --primary-color: #1da1f2;\r\n  --primary-hover: #1a8cd8;\r\n  --accent-color: #1da1f2;\r\n  --accent-color-faded: rgba(29, 161, 242, 0.1);\r\n}\r\n\r\n[data-theme=\"dimmed-purple\"] {\r\n  --bg-primary: #15202b;\r\n  --bg-secondary: #192734;\r\n  --bg-tertiary: #1e2732;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #ce93d8;\r\n  --accent-hover: #ba68c8;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #38444d;\r\n  --shadow-color: rgba(0, 0, 0, 0.3);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(206, 147, 216, 0.1);\n  --hover-bg-strong: rgba(206, 147, 216, 0.16);\r\n  --hover-background: rgba(206, 147, 216, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(206, 147, 216, 0.1);\r\n  --reputation-bg: #ce93d8;\r\n  --reputation-text: #000000;\r\n  --input-bg: #1e2732;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #38444d;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #192734;\r\n  --primary-color: #ce93d8;\r\n  --primary-hover: #ba68c8;\r\n  --accent-color: #ce93d8;\r\n  --accent-color-faded: rgba(206, 147, 216, 0.1);\r\n}\r\n\r\n[data-theme=\"dimmed-green\"] {\r\n  --bg-primary: #15202b;\r\n  --bg-secondary: #192734;\r\n  --bg-tertiary: #1e2732;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #66bb6a;\r\n  --accent-hover: #4caf50;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #38444d;\r\n  --shadow-color: rgba(0, 0, 0, 0.3);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(102, 187, 106, 0.1);\n  --hover-bg-strong: rgba(102, 187, 106, 0.16);\r\n  --hover-background: rgba(102, 187, 106, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(102, 187, 106, 0.1);\r\n  --reputation-bg: #66bb6a;\r\n  --reputation-text: #000000;\r\n  --input-bg: #1e2732;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #38444d;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #192734;\r\n  --primary-color: #66bb6a;\r\n  --primary-hover: #4caf50;\r\n  --accent-color: #66bb6a;\r\n  --accent-color-faded: rgba(102, 187, 106, 0.1);\r\n}\r\n\r\n[data-theme=\"dimmed-orange\"] {\r\n  --bg-primary: #15202b;\r\n  --bg-secondary: #192734;\r\n  --bg-tertiary: #1e2732;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #ffb74d;\r\n  --accent-hover: #ffa726;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #38444d;\r\n  --shadow-color: rgba(0, 0, 0, 0.3);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(255, 183, 77, 0.1);\n  --hover-bg-strong: rgba(255, 183, 77, 0.16);\r\n  --hover-background: rgba(255, 183, 77, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(255, 183, 77, 0.1);\r\n  --reputation-bg: #ffb74d;\r\n  --reputation-text: #000000;\r\n  --input-bg: #1e2732;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #38444d;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #192734;\r\n  --primary-color: #ffb74d;\r\n  --primary-hover: #ffa726;\r\n}\r\n\r\n[data-theme=\"dimmed-pink\"] {\r\n  --bg-primary: #15202b;\r\n  --bg-secondary: #192734;\r\n  --bg-tertiary: #1e2732;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #f06292;\r\n  --accent-hover: #ec407a;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #38444d;\r\n  --shadow-color: rgba(0, 0, 0, 0.3);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(240, 98, 146, 0.1);\n  --hover-bg-strong: rgba(240, 98, 146, 0.16);\r\n  --hover-background: rgba(240, 98, 146, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(240, 98, 146, 0.1);\r\n  --reputation-bg: #f06292;\r\n  --reputation-text: #000000;\r\n  --input-bg: #1e2732;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #38444d;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #192734;\r\n  --primary-color: #f06292;\r\n  --primary-hover: #ec407a;\r\n  --accent-color: #f06292;\r\n  --accent-color-faded: rgba(240, 98, 146, 0.1);\r\n}\r\n\r\n[data-theme=\"dimmed-teal\"] {\r\n  --bg-primary: #15202b;\r\n  --bg-secondary: #192734;\r\n  --bg-tertiary: #1e2732;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #4db6ac;\r\n  --accent-hover: #26a69a;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #17bf63;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #38444d;\r\n  --shadow-color: rgba(0, 0, 0, 0.3);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(77, 182, 172, 0.1);\n  --hover-bg-strong: rgba(77, 182, 172, 0.16);\r\n  --hover-background: rgba(77, 182, 172, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(77, 182, 172, 0.1);\r\n  --reputation-bg: #4db6ac;\r\n  --reputation-text: #000000;\r\n  --input-bg: #1e2732;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #38444d;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #192734;\r\n  --primary-color: #4db6ac;\r\n  --primary-hover: #26a69a;\r\n  --accent-color: #4db6ac;\r\n  --accent-color-faded: rgba(77, 182, 172, 0.1);\r\n}\r\n\r\n[data-theme=\"dimmed-red\"] {\r\n  --bg-primary: #15202b;\r\n  --bg-secondary: #192734;\r\n  --bg-tertiary: #1e2732;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #d62547;\r\n  --accent-hover: #c21840;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00c853;\r\n  --error-color: #f06292;\r\n  --error-bg: rgba(240, 98, 146, 0.1);\r\n  --error-border: rgba(240, 98, 146, 0.3);\r\n  --border-color: #38444d;\r\n  --shadow-color: rgba(0, 0, 0, 0.4);\r\n  --shadow-strong: rgba(0, 0, 0, 0.7);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(240, 98, 146, 0.1);\n  --hover-bg-strong: rgba(240, 98, 146, 0.16);\r\n  --hover-background: rgba(240, 98, 146, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(240, 98, 146, 0.1);\r\n  --reputation-bg: #f06292;\r\n  --reputation-text: #000000;\r\n  --input-bg: #1e2732;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #38444d;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #192734;\r\n  --primary-color: #f06292;\r\n  --primary-hover: #ec407a;\r\n  --accent-color: #f06292;\r\n  --accent-color-faded: rgba(240, 98, 146, 0.1);\r\n}\r\n\r\n/* ========================================\r\n   DARK THEME VARIATIONS\r\n   ======================================== */\r\n\r\n[data-theme=\"dark-blue\"] {\r\n  --bg-primary: #000000;\r\n  --bg-secondary: #16181c;\r\n  --bg-tertiary: #1c1f23;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #1da1f2;\r\n  --accent-hover: #1a8cd8;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00ba7c;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #2f3336;\r\n  --shadow-color: rgba(255, 255, 255, 0.05);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(29, 161, 242, 0.1);\n  --hover-bg-strong: rgba(29, 161, 242, 0.16);\r\n  --hover-background: rgba(29, 161, 242, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(29, 161, 242, 0.1);\r\n  --reputation-bg: #1da1f2;\r\n  --reputation-text: #ffffff;\r\n  --input-bg: #16181c;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #2f3336;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #16181c;\r\n  --primary-color: #1da1f2;\r\n  --primary-hover: #1a8cd8;\r\n  --accent-color: #1da1f2;\r\n  --accent-color-faded: rgba(29, 161, 242, 0.1);\r\n}\r\n\r\n[data-theme=\"dark-purple\"] {\r\n  --bg-primary: #000000;\r\n  --bg-secondary: #16181c;\r\n  --bg-tertiary: #1c1f23;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #ce93d8;\r\n  --accent-hover: #ba68c8;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00ba7c;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #2f3336;\r\n  --shadow-color: rgba(255, 255, 255, 0.05);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(206, 147, 216, 0.1);\n  --hover-bg-strong: rgba(206, 147, 216, 0.16);\r\n  --hover-background: rgba(206, 147, 216, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(206, 147, 216, 0.1);\r\n  --reputation-bg: #ce93d8;\r\n  --reputation-text: #000000;\r\n  --input-bg: #16181c;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #2f3336;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #16181c;\r\n  --primary-color: #ce93d8;\r\n  --primary-hover: #ba68c8;\r\n  --accent-color: #ce93d8;\r\n  --accent-color-faded: rgba(206, 147, 216, 0.1);\r\n}\r\n\r\n[data-theme=\"dark-green\"] {\r\n  --bg-primary: #000000;\r\n  --bg-secondary: #16181c;\r\n  --bg-tertiary: #1c1f23;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #66bb6a;\r\n  --accent-hover: #4caf50;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00ba7c;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #2f3336;\r\n  --shadow-color: rgba(255, 255, 255, 0.05);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(102, 187, 106, 0.1);\n  --hover-bg-strong: rgba(102, 187, 106, 0.16);\r\n  --hover-background: rgba(102, 187, 106, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(102, 187, 106, 0.1);\r\n  --reputation-bg: #66bb6a;\r\n  --reputation-text: #000000;\r\n  --input-bg: #16181c;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #2f3336;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #16181c;\r\n  --primary-color: #66bb6a;\r\n  --primary-hover: #4caf50;\r\n}\r\n\r\n[data-theme=\"dark-orange\"] {\r\n  --bg-primary: #000000;\r\n  --bg-secondary: #16181c;\r\n  --bg-tertiary: #1c1f23;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #ffb74d;\r\n  --accent-hover: #ffa726;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00ba7c;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #2f3336;\r\n  --shadow-color: rgba(255, 255, 255, 0.05);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(255, 183, 77, 0.1);\n  --hover-bg-strong: rgba(255, 183, 77, 0.16);\r\n  --hover-background: rgba(255, 183, 77, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(255, 183, 77, 0.1);\r\n  --reputation-bg: #ffb74d;\r\n  --reputation-text: #000000;\r\n  --input-bg: #16181c;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #2f3336;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #16181c;\r\n  --primary-color: #ffb74d;\r\n  --primary-hover: #ffa726;\r\n  --accent-color: #ffb74d;\r\n  --accent-color-faded: rgba(255, 183, 77, 0.1);\r\n}\r\n\r\n[data-theme=\"dark-pink\"] {\r\n  --bg-primary: #000000;\r\n  --bg-secondary: #16181c;\r\n  --bg-tertiary: #1c1f23;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #f06292;\r\n  --accent-hover: #ec407a;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00ba7c;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #2f3336;\r\n  --shadow-color: rgba(255, 255, 255, 0.05);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(240, 98, 146, 0.1);\n  --hover-bg-strong: rgba(240, 98, 146, 0.16);\r\n  --hover-background: rgba(240, 98, 146, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(240, 98, 146, 0.1);\r\n  --reputation-bg: #f06292;\r\n  --reputation-text: #000000;\r\n  --input-bg: #16181c;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #2f3336;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #16181c;\r\n  --primary-color: #f06292;\r\n  --primary-hover: #ec407a;\r\n}\r\n\r\n[data-theme=\"dark-teal\"] {\r\n  --bg-primary: #000000;\r\n  --bg-secondary: #16181c;\r\n  --bg-tertiary: #1c1f23;\r\n  --text-primary: #f7f9fa;\r\n  --text-secondary: #8899a6;\r\n  --text-tertiary: #6e7f8c;\r\n  --accent-primary: #4db6ac;\r\n  --accent-hover: #26a69a;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00ba7c;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #2f3336;\r\n  --shadow-color: rgba(255, 255, 255, 0.05);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(77, 182, 172, 0.1);\n  --hover-bg-strong: rgba(77, 182, 172, 0.16);\r\n  --hover-background: rgba(77, 182, 172, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(77, 182, 172, 0.1);\r\n  --reputation-bg: #4db6ac;\r\n  --reputation-text: #000000;\r\n  --input-bg: #16181c;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #2f3336;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #16181c;\r\n  --primary-color: #4db6ac;\r\n  --primary-hover: #26a69a;\r\n  --accent-color: #4db6ac;\r\n  --accent-color-faded: rgba(77, 182, 172, 0.1);\r\n}\r\n\r\n[data-theme=\"dark-red\"] {\r\n  --bg-primary: #000000;\r\n  --bg-secondary: #16181c;\r\n  --bg-tertiary: #1c1f23;\r\n  --text-primary: #e7e9ea;\r\n  --text-secondary: #71767b;\r\n  --text-tertiary: #565a5f;\r\n  --accent-primary: #e62e4d;\r\n  --accent-hover: #d6263f;\r\n  --accent-secondary: #667eea;\r\n  --accent-secondary-hover: #3752cc;\r\n  --success-color: #00ba7c;\r\n  --error-color: #ff6b9d;\r\n  --error-bg: #3d1726;\r\n  --error-border: #5d2838;\r\n  --border-color: #2f3336;\r\n  --shadow-color: rgba(255, 255, 255, 0.05);\r\n  --shadow-strong: rgba(0, 0, 0, 0.5);\r\n  --overlay-bg: rgba(0, 0, 0, 0.7);\r\n  --overlay-strong: rgba(0, 0, 0, 0.85);\r\n  --hover-bg: rgba(255, 107, 157, 0.1);\n  --hover-bg-strong: rgba(255, 107, 157, 0.16);\r\n  --hover-background: rgba(255, 107, 157, 0.1);\r\n  --like-color: #f91880;\r\n  --like-bg: rgba(249, 24, 128, 0.1);\r\n  --unread-bg: rgba(255, 107, 157, 0.1);\r\n  --reputation-bg: #ff6b9d;\r\n  --reputation-text: #000000;\r\n  --input-bg: #16181c;\r\n  --input-text: #f7f9fa;\r\n  --input-border: #2f3336;\r\n  --input-placeholder: #6e7f8c;\r\n  --card-bg: #16181c;\r\n  --primary-color: #ff6b9d;\r\n  --primary-hover: #ff4081;\r\n  --accent-color: #ff6b9d;\r\n  --accent-color-faded: rgba(255, 107, 157, 0.1);\r\n}\r\n\r\n/* Apply theme to body and html */\r\nhtml, body {\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n/* Input placeholder styling */\r\ninput::placeholder,\r\ntextarea::placeholder {\r\n  color: var(--input-placeholder);\r\n  opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
